import React, { FC, useState } from 'react'
import styled from 'styled-components'

import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../../interfaces'
import { Text, Title } from '../CssStyled'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import ExamplesPreview from './ExamplesPreview'
import {
  PreviewItemType,
  PreviewSliderItem,
  sliderBanners,
  sliderEcommerce,
  sliderMailing,
  sliderNative,
} from './utils'
import Card from './Card'
import { Trans, lng } from '@ads/front-core/locales'

const OurPossibilities: FC<ISection> = ({ setActiveMenu }) => {
  const [activeItems, setActiveItems] = useState<PreviewSliderItem[]>(null)

  const handlePreview = (previewType: PreviewItemType) => {
    switch (previewType) {
      case 'mailing':
        setActiveItems(sliderMailing)
        break
      case 'banners':
        setActiveItems(sliderBanners)
        break
      case 'ecommerce':
        setActiveItems(sliderEcommerce)
        break
      case 'native':
        setActiveItems(sliderNative)
        break
      default:
        return null
    }
  }

  const onClose = () => setActiveItems(null)

  return (
    <InfinityObserver callback={() => setActiveMenu('our-possibilities')}>
      {activeItems && (
        <ExamplesPreview
          items={activeItems}
          onClose={onClose}
        ></ExamplesPreview>
      )}
      <TitleWrapper>
        <Title as="div">
          <Trans
            i18nKey="landing:knowBetterAboutOurPossibilities"
            components={{ bold: <Title bold /> }}
          />
        </Title>

        <Cards>
          <Card
            title={lng('landing:mailing')}
            img="/img/landing/mailing/mailing.png"
            onClick={() => handlePreview('mailing')}
          >
            <ListTitleWrapper>
              <Trans
                i18nKey="landing:mailingTitle"
                components={{ bold: <Text bold /> }}
              />
            </ListTitleWrapper>
            <List>
              <Trans
                i18nKey="landing:mailingElements"
                components={{ listElement: <li /> }}
              />
            </List>
          </Card>

          <Card
            title={lng('landing:banners')}
            img="/img/landing/banner/banner.png"
            isReversed
            onClick={() => handlePreview('banners')}
          >
            <ListTitleWrapper>
              <Trans
                i18nKey="landing:bannersTitle"
                components={{ bold: <Text bold /> }}
              />
            </ListTitleWrapper>
            <List>
              <Trans
                i18nKey="landing:bannersElements"
                components={{ listElement: <li /> }}
              />
            </List>
          </Card>

          <Card
            title={lng('landing:ecommerce')}
            img="/img/landing/ecommerce/ecommerce.png"
            onClick={() => handlePreview('ecommerce')}
          >
            <ListTitleWrapper>
              <Trans
                i18nKey="landing:ecommerceTitle"
                components={{ bold: <Text bold /> }}
              />
            </ListTitleWrapper>
            <List>
              <Trans
                i18nKey="landing:ecommerceElements"
                components={{ listElement: <li /> }}
              />
            </List>
          </Card>

          <Card
            title={lng('landing:nativeAdvertisement')}
            img="/img/landing/native/native.png"
            isReversed
            onClick={() => handlePreview('native')}
          >
            <ListTitleWrapper>
              <Trans
                i18nKey="landing:nativeAdvertisementTitle"
                components={{ bold: <Text bold /> }}
              />
            </ListTitleWrapper>
            <List>
              <Trans
                i18nKey="landing:nativeAdvertisementElements"
                components={{ listElement: <li /> }}
              />
            </List>
          </Card>
        </Cards>
      </TitleWrapper>
    </InfinityObserver>
  )
}

const TitleWrapper = styled.div`
  margin-top: 104px;
  margin-bottom: 80px;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin-top: 58px;
    margin-bottom: 52px;
  }
`

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  gap: 50px;

  @media (max-width: ${breakpoints.MOBILE}) {
    gap: 40px;
  }
`

const ListTitleWrapper = styled.div`
  margin-bottom: 24px;
`

const List = styled.ul`
  margin: 0;
`

export default OurPossibilities
